export type RegistryItem = {
  type: string; // 'texto', 'imagem', etc
  label: string;
  defaultProps: Record<string, any>;
};

export const REGISTRY: RegistryItem[] = [
  { type: 'texto', label: 'Texto', defaultProps: { text: 'Novo texto' } },
  { type: 'imagem', label: 'Imagem', defaultProps: { src: '', alt: '' } },
  { 
    type: 'cronometro', 
    label: 'Cronômetro', 
    defaultProps: { 
      timerType: 'minutes',
      backgroundColor: '#ef4444',
      textColor: '#ffffff',
      timeValue: 15,
      activeText: 'Oferta por tempo limitado',
      expiredText: 'O tempo acabou!',
      fixedTop: false
    } 
  },
];
